"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.updateInputStateValue = updateInputStateValue;
function updateInputStateValue(inputElement, stateKey, newValue) {
  return {
    payload: {
      inputElement,
      newValue,
      stateKey
    },
    type: 'updateInputStateValue'
  };
}